import { FormattedMessage } from 'react-intl';
import { assertExhaustive } from '../../../../../utils';
import { FunctionComponent } from 'react';
import { MeansOfTransportType } from '../../../sharedComponents/common.types';
import { NoValue } from '../../../sharedComponents/NoValue';
import { DisplayCancellableData } from './DisplayCancellableData';

export const DisplayMeansOfTransportType: FunctionComponent<{
    meansOfTransportType: MeansOfTransportType;
}> = ({ meansOfTransportType }) => {
    switch (meansOfTransportType) {
        case MeansOfTransportType.TRUCK:
            return <FormattedMessage id="outboundOrderBook.common.meansOfTransportType.truck" />;
        case MeansOfTransportType.OWN_WHEELS:
            return <FormattedMessage id="outboundOrderBook.common.meansOfTransportType.ownWheels" />;
        case MeansOfTransportType.RORO_VESSEL:
            return <FormattedMessage id="outboundOrderBook.common.meansOfTransportType.roroVessel" />;
        case MeansOfTransportType.CONTAINER_VESSEL:
            return <FormattedMessage id="outboundOrderBook.common.meansOfTransportType.containerVessel" />;
        case MeansOfTransportType.TRAIN:
            return <FormattedMessage id="outboundOrderBook.common.meansOfTransportType.train" />;
        default:
            assertExhaustive(meansOfTransportType);
    }
};

export const DisplayMeansOfTransportId: FunctionComponent<{
    meansOfTransportId?: string;
    isCancelled: boolean;
}> = ({ meansOfTransportId, isCancelled }) => {
    return meansOfTransportId ? (
        <DisplayCancellableData isCancelled={isCancelled}>{meansOfTransportId}</DisplayCancellableData>
    ) : (
        <NoValue />
    );
};
